import React from 'react';
import AuthenticatedApp from './AuthenticatedApp';
// TODO: Restore MSAL auth templates when PingID is implemented
// import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
// import UnauthenticatedApp from './UnauthenticatedApp';

const App = () => (
    <AuthenticatedApp />
  );

export default App;
